import { KeyedObject } from '../abelcommon';
import axios from 'axios';
import { useQuery } from 'react-query';
import { environment } from '../config/environment';

export function fetchAddresses( start?: number, count?: number) {
  const searchParams = new URLSearchParams();
  if (start !== undefined) {
    searchParams.append('start', String(start));
  }
  if (count !== undefined) {
    searchParams.append('count', String(count));
  }
  return axios.get(`${environment.apiBase}/address/list?${searchParams.toString()}`).then((res) => res.data);
}

export function useAddresses(start?: number, count?: number, options?: KeyedObject) {
  return useQuery(['addresses', start, count], () => fetchAddresses(start, count), {
    retry: false,
    staleTime: 1000 * 60 * 5,
    cacheTime: 1000 * 60 * 5,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    keepPreviousData: true,
    ...options,
  });
}

export default useAddresses;
